import { LitElement } from 'lit-element';

export default class TemplateLitElement extends LitElement {
    __templates = {};

    getSlotContent(name = '', clone = false) {
        return !clone ? this.__templates[name] : this.__templates[name].clone(true);
    }

    updateSlotsContent() {
        const templates = Array.from(this.querySelectorAll('template'));

        if (templates.length) {
            this.__templates = templates.reduce((acc, template) => {
                const slot = document.createElement('v-slot-assigned-content');
                slot.innerHTML = template.innerHTML;
                if (template.name) {
                    slot.name = template.name;
                }
                return { ...acc, [template.name || '']: slot };
            }, {});
        }
    }

    connectedCallback() {
        super.connectedCallback();
        this.updateSlotsContent();
    }

    createRenderRoot() {
        return this;
    }
}
